import React, { useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SmartLink } from './SmartLink';
const stories = [{
  business: 'All-in-one supermarket',
  quote: '“Kayko helps me keep my stock organized, track every sale, and make sure I never run out of the products my customers need.”',
  name: 'Jemima Nyirasafari',
  role: 'Owner',
  cta: 'Read her story',
  href: '/customers/all-in-one-supermarket',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/26e15333-45ec-4421-ac04-24cf98518008.jpg'
}, {
  business: 'YEET Coffee',
  quote: '“With Kayko, I can manage sales, monitor my products, and follow the growth of YEET Coffee without the usual stress.”',
  name: 'Héritier Muhire',
  role: 'Founder',
  cta: 'Read his story',
  href: '/customers/yeet-coffee',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/c04828fc-7f33-4022-bb39-af6bdb618150.jpg'
}, {
  business: 'Job’s Clothing Shop',
  quote: '“Kayko makes it easier to track my sales and expenses, run my business efficiently, and plan confidently for growth.”',
  name: 'Job Gashangaza',
  role: 'Owner',
  cta: 'Read his story',
  href: '/customers/jobs-clothing-shop',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/1f9a33f4-6198-4f9d-89dd-0aca07eb18bb.jpg'
}];
export function Testimonial() {
  const [active, setActive] = useState(0);
  const current = stories[active];
  return <section className="w-full bg-canvas-warm py-20" aria-labelledby="stories-heading" data-id="element-1662" data-mp="37l37hxd9f6s9">
      <div className="mx-auto max-w-shell px-6" data-id="element-1663" data-mp="3m9pxqu4fdiy9">
        <h2 id="stories-heading" className="display text-center text-[32px] font-semibold text-ink sm:text-[40px]" data-id="element-1664" data-mp="3maiur3dl0u37">
          See how businesses grow with Kayko.
        </h2>

        <div role="tablist" aria-label="Customer stories" className="no-scrollbar mx-auto mt-10 flex max-w-[820px] justify-start gap-8 overflow-x-auto border-b border-canvas-line sm:justify-center" data-id="element-1665" data-mp="2tr2dti1609yr">
          {stories.map((story, i) => <button key={story.business} role="tab" type="button" id={`story-tab-${i}`} aria-selected={active === i} aria-controls="story-panel" onClick={() => setActive(i)} className={`-mb-px whitespace-nowrap border-b-2 pb-3 text-[14px] font-medium transition-colors duration-150 ease-out ${active === i ? 'border-ink text-ink' : 'border-transparent text-ink-muted hover:text-ink'}`} data-id="element-1666" data-mp="xo7hu5hvct1t" data-mpi={i}>
              {story.business}
            </button>)}
        </div>

        <div id="story-panel" role="tabpanel" aria-labelledby={`story-tab-${active}`} className="mt-12 grid grid-cols-1 items-center gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-16" data-id="element-1667" data-mp="1u7wwbl43ppwy">
          <img src={current.image} alt={`${current.name}, ${current.role} of ${current.business}`} className="h-[380px] w-full rounded-[12px] object-cover" data-id="element-1668" data-mp="29a6kbd2g2b3o" />

          <div className="max-w-[480px]" data-id="element-1669" data-mp="1zj24yc8uwo8b">
            <p className="text-[18px] font-bold tracking-[-0.02em] text-brand" data-id="element-1670" data-mp="1vjji3axh632u">
              {current.business}
            </p>
            <blockquote className="display mt-8 text-[24px] font-semibold text-ink sm:text-[28px]" data-id="element-1671" data-mp="1ql889076jskm">
              {current.quote}
            </blockquote>
            <p className="mt-6 text-[14px] text-ink-muted" data-id="element-1672" data-mp="1gm0x8jnx4a0o">
              <span className="font-semibold text-ink" data-id="element-1673" data-mp="1gmj1o3kqhujo">{current.name}</span>, {current.role}
            </p>
            <SmartLink href={current.href} className="mt-7 inline-flex items-center gap-2 text-[15px] font-medium text-brand transition-colors duration-150 ease-out hover:text-brand-hover" data-id="element-1674" data-mp="1cm8l5wzbflqk">
              {current.cta}
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1675" data-mp="3e1ddkpwlz1vv" />
            </SmartLink>
          </div>
        </div>
      </div>
    </section>;
}